import { render, staticRenderFns } from "./resales.vue?vue&type=template&id=6b428b14"
import script from "./resales.vue?vue&type=script&lang=js"
export * from "./resales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports